module.exports = __webpack_public_path__ + "static/media/addimage.ca513b22.svg";